import MenuComponent from "../../../menu/menu";
import "../require-login.scss";
import DETAIL_RESUME from "../../../../assets/images/guest/group-guest-resume.png"
import IMG_AI_1 from "../../../../assets/images/guest/ai-1.png"
import IMG_AI_2 from "../../../../assets/images/guest/ai2.png"
import IMG_RESUME from "../../../../assets/images/guest/resume.png";
import TEXT_RESUME from "../../../../assets/images/guest/text-resume.png";
import BG_RESUME from "../../../../assets/images/guest/my-resume.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import AuthFunction from "../../../../services/sso/auth.function";
import navigationService from "../../../../services/navigation.service";
import config from "../../../../config";
import tokenService from "../../../../services/sso/token.service";
import UtilityService from "../../../../utility/utility.service";

const GuestMyResumeComponent = () => {

    const navigate = useNavigate();
    useEffect(() => {


    }, [])

  
    const authenticateUrl = () => {
        const codeVerifier = AuthFunction().randomString(56);
        const codeChallenge = AuthFunction().PKCEencoding(codeVerifier);
        const state = AuthFunction().randomString(config.authen.length);
        let path = "/profile";
        if (navigationService.getPath()) {
            path = navigationService.getPath();
        }
        const urlReturn = config.authen.sso_url + "?" + new URLSearchParams({
            redirect_uri: config.authen.redirect_uri + "?" + new URLSearchParams({
                page: path
            }),
            state: state,
            code_challenge: codeChallenge,
            response_type: 'code',
            code_challenge_method: 'S256',
            client_id: config.authen.client_id
        })
        tokenService.setVerifyCode(codeVerifier)
        window.open(urlReturn, "_self");
    }
    const onClickRegister= () => {
        UtilityService().clickSendEvent("guest_my_resume_register", "click");
        authenticateUrl();
    }
    const onClickLogin = () => {
        UtilityService().clickSendEvent("guest_my_resume_login", "click");
        authenticateUrl();
    }
    return (

        <>
            <div className="main-control">
                <MenuComponent></MenuComponent>

                <div className="guest-require-login" style={{ backgroundImage: `url(${BG_RESUME})` }}>
                    <div className="guest-require-login-border-control">
                        <img src={IMG_AI_1} className="guest-require-login-img-ai-1"></img>
                        <img src={IMG_AI_2} className="guest-require-login-img-ai-2"></img>
                        <img src={IMG_AI_2} className="guest-require-login-img-ai-3"></img>
                        <img src={IMG_RESUME} className="guest-require-login-img-resume"></img>
                        <img src={TEXT_RESUME} className="guest-require-login-headtext-control"></img>
                        <img src={DETAIL_RESUME} className="guest-require-login-detail-control"></img>

                        <Button className="guest-require-login-button-register" onClick={onClickRegister}>ลงทะเบียน</Button>
                        <Button className="guest-require-login-button-login" onClick={onClickLogin}>เข้าสู่ระบบ</Button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default GuestMyResumeComponent;